/**
 * Создает URL с query-параметрами, обрабатывая массивы и исключая null/undefined
 * @param baseUrl Базовый URL (может быть абсолютным, относительным или содержать существующие параметры)
 * @param params Объект с query-параметрами
 * @returns url с query-строками
 * @throws {TypeError} Если baseUrl невалидный
 */
export function buildUrlWithQueryParams(
    baseUrl: string,
    params: Record<
        string,
        string | number | boolean | null | undefined | (string | number | boolean | null | undefined)[]
    > = {}
): string {
    try {
        // заглушка для использования URL с относительными путями
        const domainStub = 'http://localhost';
        // Создаем полный URL для обработки относительных путей
        const fullUrl = new URL(baseUrl, domainStub);

        Object.entries(params).forEach(([key, value]) => {
            // Пропускаем null и undefined значения
            if (value === null || value === undefined) {
                return;
            }

            // Обработка массивов
            if (Array.isArray(value)) {
                const validValues = value.filter((item) => item !== null && item !== undefined).map(String);

                validValues.forEach((v) => {
                    fullUrl.searchParams.append(`${key}[]`, String(v));
                });
            } else {
                // Обработка одиночных значений
                fullUrl.searchParams.append(key, String(value));
            }
        });

        // Для относительных URL возвращаем путь с параметрами
        return baseUrl.startsWith('http') ? fullUrl.toString() : fullUrl.pathname + fullUrl.search + fullUrl.hash;
    } catch (error) {
        throw new TypeError(`Invalid URL: ${baseUrl}`);
    }
}
